import useSWR, {SWRConfiguration} from 'swr';
import letrusAPI from 'APIs/letrusAPI/axiosInstance';
import {ZeroGradeComment, ZeroGradeCommentParams} from './types';

export function fetchZeroGradeComment(
  params: ZeroGradeCommentParams,
  SWRConfig?: SWRConfiguration<ZeroGradeComment[]>,
) {
  const urlParams = new URLSearchParams({
    genre_id: String(params.genre_id),
    user_role: params.user_role,
  });

  return useSWR<ZeroGradeComment[]>(
    params.genre_id ? `/api/v1/zero_grade_comment/?${urlParams}` : null,
    (url) => letrusAPI(url).then((res) => res.data?.results ?? []),
    {revalidateOnFocus: false, shouldRetryOnError: false, ...SWRConfig},
  );
}
